import script from "./PlatformAdminLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatformAdminLayout.vue?vue&type=script&setup=true&lang=ts"

import "./PlatformAdminLayout.vue?vue&type=style&index=0&id=8b3694a6&lang=scss"

const __exports__ = script;

export default __exports__